import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            navigate("/ponude/login", { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(m[1]);

        (async () => {
            try {
                const r = await fetch(`${API}/api/auth/session`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                    body: JSON.stringify({ session_id: sessionId }),
                });
                if (!r.ok) {
                    const err = await r.json().catch(() => ({}));
                    throw new Error(err.detail || "Prijava nije uspjela");
                }
                const data = await r.json();
                setUser(data.user);
                // Clean URL fragment then redirect
                window.history.replaceState({}, document.title, "/ponude");
                navigate("/ponude", { replace: true, state: { user: data.user } });
            } catch (e) {
                toast.error(e.message || "Greška pri prijavi");
                navigate("/ponude/login", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--paper))]">
            <div className="text-center">
                <div className="w-12 h-12 border-4 border-[hsl(var(--accent))] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
                <p className="text-[hsl(var(--muted-ink))]">Prijavljujemo vas...</p>
            </div>
        </div>
    );
}
